import { Helmet } from "react-helmet";
import EventActionSection from "./EventActionSection";
import EventDetailsSection from "./EventDetailsSection";
import RelatedVideosSection from "./RelatedVideosSection";
import React from "react";

export default function SingleeventPage() {
  return (
    <>
      <Helmet>
        <title>Restaurant Workshop - Food Cost Controls & Profitability</title>
        <meta
          name="description"
          content="Attend 'The 3 Most Impactful Food Cost Controls for Independent Restaurants' workshop to learn how to reduce waste and increase profitability. Discover insights from industry experts and connect with peers in Cairo."
        />
      </Helmet>
      <div className="w-full bg-gray-50">
        {/* event details section */}
        <EventDetailsSection />

        {/* related videos section */}
        <RelatedVideosSection />

        {/* event action section */}
        <EventActionSection />
      </div>
    </>
  );
}
